import { FC, useCallback } from 'react';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { Box, IconButton, Tooltip } from '@mui/material';
import { InputInteger } from '../InputInteger';
import "./styles.css";
import { CSSProperties } from '@mui/styles';

export interface InputQuantidadeParameters {
    value: number,
    label?: string,
    onChange: Function,
    disabled?: boolean,
    disabledInput?: boolean,
    disableRipple?: boolean,
    customStyle?: CSSProperties,
    size?: 'small' | 'medium' | undefined,
    highlightField?: boolean
    hasError?: boolean
    multiple?: number;
    minValue?: number,
    maxValue?: number,
    minButtonTooltip?: string,
    maxButtonTooltip?: string,
    onBlur?: (event: any) => void,
}

const InputQuantidade: FC<InputQuantidadeParameters> = ({
  value = "",
  label = "",
  disabled = false,
  disabledInput = false,
  disableRipple = false,
  highlightField = true,
  onChange = () => null,
  onBlur = () => null,
  size = "small",
  customStyle = {},
  multiple = 1,
  hasError = false,
  minValue = 0,
  maxValue,
  minButtonTooltip = "",
  maxButtonTooltip = "",
}) => {
    const onClickMais = useCallback(
        (e) => onChange(e + multiple),
        [onChange, multiple],
    );

    const onClickMenos = useCallback(
        (e) => {
            const newValue = e - multiple;
            onChange(newValue > minValue ? newValue : minValue);
        },
        [onChange, multiple],
    );

    return (
        <Box className="root" style={customStyle}>
            <Tooltip title={minButtonTooltip} placement="top">
                <IconButton 
                    size={size}
                    className="remove" 
                    disabled={disabled || Number(value) <= minValue} 
                    disableRipple={disableRipple}
                    onClick={() => onClickMenos(Number(value))}
                >
                    <RemoveIcon fontSize={size}/>
                </IconButton>
            </Tooltip>
            <InputInteger
                label={label}
                value={value || 0}
                disabled={disabled || disabledInput}
                type="number"
                className={`input ${highlightField && (Number(value) > 0 ? 'highlight' : '')}`}
                onChangeValue={(_name: string, value: any) => onChange(value)}
                hasError={hasError}
                onBlur={() => {
                    onBlur(value)
                }}
            />
            <Tooltip title={maxButtonTooltip} placement="top">
            <IconButton 
                size={size}
                className="add" 
                disabled={disabled} 
                disableRipple={disableRipple}
                onClick={() => onClickMais(Number(value))}
            >
                <AddIcon fontSize={size}/>
            </IconButton>
            </Tooltip>
        </Box>
    )
};

export default InputQuantidade;
